import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Type, Globe, Home } from "lucide-react";
import { TypographySettings } from '@/components/cms/settings/TypographySettings';
import { LanguageSettings } from '@/components/cms/settings/LanguageSettings';
import { HomeSettings } from '@/components/cms/settings/HomeSettings';

export default function Settings() {
  return (
    <div className="space-y-8">
      <div className="border-b border-border pb-6">
        <h1 className="text-3xl font-bold tracking-tight text-foreground">Settings</h1>
        <p className="text-muted-foreground mt-3 text-base">
          Configure global app settings and preferences
        </p>
      </div>

      <Tabs defaultValue="home" className="space-y-8">
        <TabsList className="grid w-full grid-cols-3 h-12 p-1 bg-muted/50 border border-border">
          <TabsTrigger value="home" className="flex items-center gap-2 h-10 px-4 text-sm font-medium transition-all data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm">
            <Home className="h-4 w-4" />
            Home
          </TabsTrigger>
          <TabsTrigger value="typography" className="flex items-center gap-2 h-10 px-4 text-sm font-medium transition-all data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm">
            <Type className="h-4 w-4" />
            Typography
          </TabsTrigger>
          <TabsTrigger value="languages" className="flex items-center gap-2 h-10 px-4 text-sm font-medium transition-all data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm">
            <Globe className="h-4 w-4" />
            Languages
          </TabsTrigger>
        </TabsList>

        <TabsContent value="home" className="mt-8">
          <Card className="border-2 border-border/50 shadow-sm">
            <CardHeader className="pb-6">
              <CardTitle className="text-xl font-semibold text-foreground">Home Page Settings</CardTitle>
              <CardDescription className="text-base text-muted-foreground">
                Configure which elements are displayed on the home page
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-0">
              <HomeSettings />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="typography" className="mt-8">
          <Card className="border-2 border-border/50 shadow-sm">
            <CardHeader className="pb-6">
              <CardTitle className="text-xl font-semibold text-foreground">Typography Settings</CardTitle>
              <CardDescription className="text-base text-muted-foreground">
                Customize the fonts used throughout the application
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-0">
              <TypographySettings />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="languages" className="mt-8">
          <Card className="border-2 border-border/50 shadow-sm">
            <CardHeader className="pb-6">
              <CardTitle className="text-xl font-semibold text-foreground">Language Management</CardTitle>
              <CardDescription className="text-base text-muted-foreground">
                Manage supported languages and default language settings
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-0">
              <LanguageSettings />
            </CardContent>
          </Card>
        </TabsContent>

      </Tabs>
    </div>
  );
}